export enum PrintFontStyle {
  REGULAR = 'REGULAR',
  BOLD = 'BOLD',
  ITALIC = 'ITALIC',
  BOLD_ITALIC = 'BOLD_ITALIC',
  UNDERLINE = 'UNDERLINE',
  STRIKEOUT = 'STRIKEOUT',
}
